import { BAG_BANNER_SHOWN } from "./constants";

export const bagBannerShown = () => dispatch => {
  dispatch({
    type: BAG_BANNER_SHOWN
  });
};
